import { graphql, useStaticQuery } from 'gatsby';

type NavigationQuery = {
  main: Queries.NavigationBarFragment['pages'];
  mobile: Queries.NavigationBarFragment['pages'];
  secondary: Queries.NavigationBarFragment['pages'];
  mobileDropdown: Queries.NavigationBarFragment['dropdowns'];
};

const useNavigationQuery = (): NavigationQuery => {
  const { main, mobile, secondary, mobileDropdown } = useStaticQuery(graphql`
    query NavBar {
      main: contentfulNavigationBar(slug: { eq: "nav-site-main" }) {
        ...NavigationBar
      }
      mobileDropdown: contentfulNavigationBar(slug: { eq: "site-nav-mobile-dropdown" }) {
        ...NavigationBar
      }
      mobile: contentfulNavigationBar(slug: { eq: "nav-site-main-mobile" }) {
        ...NavigationBar
      }
      secondary: contentfulNavigationBar(slug: { eq: "nav-site-secondary" }) {
        ...NavigationBar
      }
    }
  `);

  return {
    main: main?.pages ?? [],
    mobile: mobile?.pages ?? [],
    secondary: secondary?.pages ?? [],
    mobileDropdown: mobileDropdown?.dropdowns ?? [],
  };
};

export default useNavigationQuery;
